import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { HotelColorDirective, SlideToggleColorDirective } from '../../directives';
import { CustomIconComponent } from '../custom-icon/custom-icon.component';

export interface ToggleOptionBoxItem {
  key: string;
  label: string;
  icon: string;
  selected: boolean;
  type?: string;
}

@Component({
  selector: 'ctr-toggle-options-box',
  imports: [MatSlideToggleModule, MatIconModule, HotelColorDirective, SlideToggleColorDirective, CustomIconComponent],
  templateUrl: './toggle-options-box.component.html',
  styleUrl: './toggle-options-box.component.scss',
})
export class ToggleOptionsBoxComponent {
  @Input() items: ToggleOptionBoxItem[] = [];
  @Input() addOptionText?: string;
  @Output() itemSelected = new EventEmitter<ToggleOptionBoxItem>();
  @Output() itemToggle = new EventEmitter<ToggleOptionBoxItem>();
  @Output() addOption = new EventEmitter<void>();
  @Output() removeOption = new EventEmitter<number>();

  toggleOption(key: string, value: boolean) {
    const item = this.items.find((i) => i.key === key);
    if (item) {
      item.selected = value;
      this.itemToggle.emit(item);
      this.items = [...this.items];
    }
  }
}
